import { Link, useLocation } from 'react-router-dom';
import { t } from '../i18n';
import { useAuth } from '../stores/auth';

/** Початковий пароль власника з .env (XQ_SEED_OWNER_PASSWORD) ще не змінено — нагадуємо на кожній сторінці. */
export function PasswordWarning() {
  const must = useAuth((s) => !!s.me?.user?.must_change_password);
  const { pathname } = useLocation();
  if (!must) return null;
  return (
    <div role="alert" className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-3 rounded-lg bg-warn-soft mb-4">
      <span className="font-semibold">{t('password.seedWarning')}</span>
      {pathname !== '/settings/security' && (
        <Link to="/settings/security" className="link text-sm whitespace-nowrap">
          {t('password.seedLink')}
        </Link>
      )}
    </div>
  );
}
